// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","active":"menu_active__wzdzQ"};